// Sunucu ve istemcinin ortak, yan etkisiz oynatma kuralları.

/** Son bu kadar saniye içindeki bitiş gerçek son sayılır. */
const END_MARGIN_SEC = 8;

/**
 * Akış bittiğinde, bilinen süreye göre bu erken bir kopuş mu? Süre
 * bilinmiyorsa bitişe güvenilir (erken diyemeyiz).
 */
export function isPrematureEnd(positionSec: number, durationSec: number | null | undefined): boolean {
  if (!durationSec || !(durationSec > 0) || !Number.isFinite(positionSec)) return false;
  return positionSec < durationSec - END_MARGIN_SEC;
}
